import React from 'react';
import './LoadingOverlay.css';

const LoadingOverlay = ({ show, message = 'Processing...', type = 'loading' }) => {
  if (!show) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <i className="fas fa-check-circle"></i>;
      case 'error':
        return <i className="fas fa-exclamation-circle"></i>;
      case 'warning':
        return <i className="fas fa-exclamation-triangle"></i>;
      default:
        return <div className="spinner"></div>;
    }
  };

  const getTitle = () => {
    switch (type) {
      case 'success':
        return 'Success!';
      case 'error':
        return 'Error!';
      case 'warning':
        return 'Warning!';
      default:
        return 'Processing...';
    }
  };

  return (
    <div className={`loading-overlay ${type}`}>
      <div className="loading-content">
        {getIcon()}
        <h3>{getTitle()}</h3>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default LoadingOverlay;
